<template>
  <div class="dialog"  v-show="show">
    <div class="dialog-box">
      <img class="dialog-box-close" src="../../assets/close-icon.png" alt="" @click="onClose"/>
      <div class="dialog-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    }
  },
  props:{
      show:false
  },
  name:'dialog',
  components:{
    
  },
  computed(){
    console.log(show);
    
  },
  watch:{
     show:{
        handler (newV, oldV) {
            this.show = newV
            console.log(this.show)
        },
        deep:true
      }
  },
  mounted(){
  
  },
  methods: {
    onClose(){
      this.$emit("onClose");
    }
    
  }
}

</script>
<style lang="less" scoped>
    .dialog{
      position: fixed;
      width: 100vw;
      height: 100vh;
      display: flex;
      top: 0;
      left: 0;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.35);
      z-index: 999;
      .dialog-box{
        min-height: 250px;
        min-width: 430px;
        position: relative;
        background: white;
        border-radius: 10px;
        .dialog-box-close{
          width: 28px;
          height: 28px;
          position: absolute;
          right: -28px;
          top: -28px;
          cursor: pointer;
        }
      }

    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/index.vue